// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-display:hover .edit-icon[data-v-6267691d]{visibility:visible}[data-v-6267691d] .remove-padding .v-input__control .v-input__slot{padding:0!important}.textarea-dimensions[data-v-6267691d]{min-height:40px;margin-right:1.5rem!important;margin-top:.1rem}[data-v-6267691d] .v-text-field__details{margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
